import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInterceptor";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const ADMIN_BASE = process.env.REACT_APP_ADMIN_SERVICES_BASE || "";

export const b2bUserDetails = createAsyncThunk("b2bUserDetails", async () => {
  try {
    const { data } = await axios.get(`${GATEWAY_BASE + ADMIN_BASE}/getMyInfo`);

    return data;
  } catch (error: any) {
    // Throw the entire error object to be caught in the rejected case
    throw error.response?.data.statusCode;
  }
});

const b2bUserDetailsSlice = createSlice({
  name: "b2bUserDetails",
  initialState: {
    loading: false,
    b2bUser: localStorage.getItem("b2bUser")
      ? JSON.parse(localStorage.getItem("b2bUser")!)
      : null,
    error: false,
    errorData: null as any,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(b2bUserDetails.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(b2bUserDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.b2bUser = action.payload;

      localStorage.setItem("b2bUser", JSON.stringify(action.payload));
    });
    builder.addCase(b2bUserDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorData = action.error;
    });
  },
});

export default b2bUserDetailsSlice.reducer;
